import React, { useEffect, useRef } from 'react'
import RobotSVG from 'assets/icons/Robot.svg'
import { reactAppGRecaptchaKey } from 'utils/config'
import { isLocal, isRecaptchaRequired } from 'utils/globals'
import mountRecaptchaWidget, { GRECAPTCHA_WIDGET_ID, unmountRecaptcha } from 'services/GRecaptcha'

function GRecaptcha ({ callback, hasFetchError, setHasFetchError }: { callback: (token: string) => void, hasFetchError: boolean, setHasFetchError: (err: boolean) => void }) {
  const siteKey = reactAppGRecaptchaKey ?? ''
  const callbackRef = useRef(callback)

  callbackRef.current = callback

  useEffect(() => {
    if (!isRecaptchaRequired()) return

    const handleError = (hasError: boolean) => {
      setHasFetchError(hasError)
    }

    mountRecaptchaWidget(
      siteKey,
      (token) => callbackRef.current(token),
      handleError
    )

    return () => {
      unmountRecaptcha()
    }
  }, [setHasFetchError, siteKey])

  useEffect(() => {
    if (isLocal && hasFetchError) callbackRef.current('')
  }, [hasFetchError])

  const showRecaptchaLoadError = hasFetchError && isRecaptchaRequired()

  return (
    <div className='grecaptcha-modal'>
      <img className='grecaptcha-modal__img' src={RobotSVG} alt='Robot' />
      <div>
        <h2 className='grecaptcha-modal__title m-1'>
          Precisamos verificar se você é humano
        </h2>
        <p className='grecaptcha-modal__description m-1'>
          Por favor, complete o reCAPTCHA para prosseguir com o login.
        </p>
      </div>

      {showRecaptchaLoadError && (
        <p className='grecaptcha-modal__description m-1'>
          Não foi possível carregar o reCAPTCHA. Recarregue a página e tente
          novamente.
        </p>
      )}

      <div id={GRECAPTCHA_WIDGET_ID} className='grecaptcha-modal__widget' />
    </div>
  )
}

export default GRecaptcha
